import React from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Button from "react-validation/build/button";
import requiredFieldValidator from "../validations/requiredField";
import emailValidator from "../validations/email";
import usernameValidator from "../validations/username";
import passwordValidator from "../validations/password";
import passwordConfirmationValidator from "../validations/passwordConfirmation";
import renderErrors from "../validations/renderErrors";

const SignupForm = ({
  checkButton,
  closeModal,
  email,
  errors,
  form,
  handleSubmit,
  onChangeEmail,
  onChangePassword,
  onChangePasswordConfirmation,
  onChangeUsername,
  password,
  passwordConfirmation,
  setErrors,
  username,
}) => (
  <>
    <button className="close-btn" onClick={closeModal}>
      X
    </button>
    <h2>Sign Up</h2>
    <Form
      onChange={() => {
        setErrors({});
      }}
      onSubmit={handleSubmit}
      ref={form}
    >
      <div className="api-error">{errors && renderErrors(errors)}</div>
      <div className="input-container" id="input-container">
        <Input
          type="text"
          name="username"
          value={username}
          placeholder="username"
          className="input-field"
          onChange={onChangeUsername}
          ref={form}
          validations={[requiredFieldValidator, usernameValidator]}
        />
      </div>
      <div className="input-container">
        <Input
          type="email"
          name="email"
          value={email}
          placeholder="email"
          className="input-field"
          onChange={onChangeEmail}
          ref={form}
          validations={[emailValidator, requiredFieldValidator]}
        />
      </div>
      <div className="input-container">
        <Input
          type="password"
          name="password"
          value={password}
          placeholder="password"
          className="input-field"
          onChange={onChangePassword}
          ref={form}
          validations={[passwordValidator, requiredFieldValidator]}
        />
      </div>
      <div className="input-container">
        <Input
          type="password"
          name="password_confirmation"
          value={passwordConfirmation}
          placeholder="confirm password"
          className="input-field"
          onChange={onChangePasswordConfirmation}
          ref={form}
          validations={[
            passwordConfirmationValidator,
            passwordValidator,
            requiredFieldValidator,
          ]}
        />
      </div>
      <div>
        <button className="auth-btn">Sign Up</button>
        <Button style={{ display: "none" }} ref={checkButton} />
      </div>
    </Form>
  </>
);

export default SignupForm;
